<section class="my-5 container-lg text-center">
  <h1 class="text-primary display-1">
    <strong>404</strong>
  </h1>
  <h2>Страницата не е намерена</h2>
  <p>Страницата, която търсите, може да е премахната, нейното име да е променено или временно да не е достъпна.</p>
  <a class="btn btn-primary"
     [routerLink]="[appRoutes.root]">
    Върни се към началната страница
  </a>
</section>
